import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "xform-section" }
const _hoisted_2 = { class: "xfields" }
const _hoisted_3 = {
  key: 0,
  class: "xfield form-field xfield-group"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "input-wrapper-outer" }
const _hoisted_6 = ["title", "selected", "value"]
const _hoisted_7 = {
  class: "input-wrapper-outer",
  style: {"flex":"1"}
}
const _hoisted_8 = { class: "input-wrapper-inner" }
const _hoisted_9 = { class: "prefix" }
const _hoisted_10 = { class: "xfield form-field" }
const _hoisted_11 = { class: "input-wrapper-outer" }
const _hoisted_12 = ["title", "selected", "value"]
const _hoisted_13 = { class: "xfield form-field xfield-group" }
const _hoisted_14 = {
  class: "input-wrapper-outer",
  style: {"flex":"1"}
}
const _hoisted_15 = { class: "input-wrapper-inner" }
const _hoisted_16 = { class: "prefix" }

import { computed, onBeforeMount, ref, toRefs } from "vue";
import { AddressCountryIds, AddressTypeIds } from "@/config/constants";
import type { Address } from "@/models/application";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { Field as VeeField, ErrorMessage } from "vee-validate";
import { FormModes } from "@/models/form";
import useStudentAddressForm from "@/composables/forms/useStudentAddressForm";
import { useStore } from "vuex";
import type { StudentVM } from "@/models/student";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentAddressInput',
  props: {
    mode: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();

const props = __props;

const { mode } = toRefs(props);

const address = ref<Address>({
  address1: "",
  address2: null as null | string,
  addressTypeId: AddressTypeIds.PermanentAddress,
  addressTypeName: null,
  addressUnitTypeId: null as null | number,
  addressUnitTypeName: null as null | string,
  applicantId: 0,
  id: 0,
  city: "",
  stateId: 0,
  stateName: "",
  postalCode: "",
  countryId: AddressCountryIds.USA,
  countryName: "",
});

const selectedStudent = computed<StudentVM | undefined>(
  () => store.state.loanConfigurationModule.applicationInfo.student,
);

const originalAddress = computed<Address>(() => {
  if (selectedStudent.value?.addresses && selectedStudent.value?.addresses?.length > 0) {
    return selectedStudent.value?.addresses[0];
  }
  return defaultAddress.value;
});

const updatedAddress = computed<Address>(() => {
  return {
    address1: values?.address1 || "",
    address2: formattedAddress2.value,
    addressTypeId: address.value?.addressTypeId || AddressTypeIds.PermanentAddress,
    addressTypeName: address.value?.addressTypeName || "",
    addressUnitTypeId: address.value?.addressUnitTypeId || null,
    addressUnitTypeName: address.value?.addressUnitTypeName || null,
    applicantId: address.value?.applicantId || selectedStudent.value?.applicantId || 0,
    id: address.value?.id || 0,
    city: address.value?.city || "",
    stateId: address.value?.stateId || 0,
    stateName: address.value?.stateName || "",
    postalCode: address.value?.postalCode || "",
    countryId: address.value?.countryId || 0,
    countryName: address.value?.countryName || "",
  };
});

const {
  addressBackup,
  addressSchema,
  addressUnitTypes,
  countryOptions,
  defaultAddress,
  discardChanges,
  errors,
  formatAddress2,
  formattedAddress2,
  formatZipCode,
  handleFieldChange,
  hasErrors,
	prefixes,
  resetSchemas,
  selectedUnitType,
  setValues,
  setFieldValue,
  setAddress,
  statesOptions,
  values,
} = useStudentAddressForm({
  address,
  mode,
  initialValues: originalAddress,
});


__expose({
  address,
  addressBackup,
  discardChanges,
  errors,
  formatAddress2,
  formattedAddress2,
  formatZipCode,
  hasErrors,
  originalAddress,
	prefixes,
  resetSchemas,
  setAddress,
  setFieldValue,
  setValues,
  updatedAddress,
  values,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).address1,
        modelValue: address.value.address1,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((address.value.address1) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_unref(handleFieldChange)('address1', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "input-group",
              disabled: __props.disabled
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[21] || (_cache[21] = _createElementVNode("label", {
                  class: "label cuscd-form-field-label",
                  for: "addressUnitTypeId"
                }, "Unit Type", -1)),
                _createVNode(_unref(VeeField), {
                  name: "addressUnitTypeId",
                  modelValue: address.value.addressUnitTypeId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address.value.addressUnitTypeId) = $event)),
                  onHandleChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleFieldChange)('addressUnitTypeId', $event)))
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("select", _mergeProps({
                      class: "form-control select",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address.value.addressUnitTypeId) = $event))
                    }, field), [
                      _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressUnitTypes), (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          title: option.name,
                          selected: option.id === Number(address.value.addressUnitTypeId),
                          value: option.id
                        }, _toDisplayString(option.name), 9, _hoisted_6))
                      }), 128))
                    ], 16), [
                      [_vModelSelect, address.value.addressUnitTypeId]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), {
                    class: "error-message",
                    name: "addressUnitTypeId"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[22] || (_cache[22] = _createElementVNode("label", {
                  class: "label cuscd-form-field-label",
                  for: "address2"
                }, "Unit Number", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(selectedUnitType)?.abbreviation), 1),
                  _createVNode(_unref(VeeField), {
                    type: "text",
                    name: "address2",
                    modelValue: address.value.address2,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address.value.address2) = $event)),
                    onHandleChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(handleFieldChange)('address2', $event)))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), {
                    class: "error-message",
                    name: "address2"
                  })
                ])
              ])
            ], 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[24] || (_cache[24] = _createElementVNode("label", {
            class: "label cuscd-form-field-label",
            for: "addressUnitTypeId"
          }, "Unit Type", -1)),
          _createVNode(_unref(VeeField), {
            name: "addressUnitTypeId",
            modelValue: address.value.addressUnitTypeId,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((address.value.addressUnitTypeId) = $event)),
            onHandleChange: _cache[9] || (_cache[9] = ($event: any) => (_unref(handleFieldChange)('addressUnitTypeId', $event)))
          }, {
            default: _withCtx(({ field }) => [
              _withDirectives(_createElementVNode("select", _mergeProps({
                class: "form-control select",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((address.value.addressUnitTypeId) = $event))
              }, field), [
                _cache[23] || (_cache[23] = _createElementVNode("option", { value: null }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressUnitTypes), (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.id,
                    title: option.name,
                    selected: option.id === Number(address.value.addressUnitTypeId),
                    value: option.id
                  }, _toDisplayString(option.name), 9, _hoisted_12))
                }), 128))
              ], 16), [
                [_vModelSelect, address.value.addressUnitTypeId]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", null, [
            _createVNode(_unref(ErrorMessage), {
              class: "error-message",
              name: "addressUnitTypeId"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "label cuscd-form-field-label",
            for: "address2"
          }, "Unit Number", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(selectedUnitType)?.abbreviation), 1),
            _createVNode(_unref(VeeField), {
              type: "text",
              name: "address2",
              modelValue: address.value.address2,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((address.value.address2) = $event)),
              onHandleChange: _cache[11] || (_cache[11] = ($event: any) => (_unref(handleFieldChange)('address2', $event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(ErrorMessage), {
              class: "error-message",
              name: "address2"
            })
          ])
        ])
      ]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).city,
        modelValue: address.value.city,
        "onUpdate:modelValue": [
          _cache[12] || (_cache[12] = ($event: any) => ((address.value.city) = $event)),
          _cache[13] || (_cache[13] = ($event: any) => (_unref(handleFieldChange)('city', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).stateId,
        modelValue: address.value.stateId,
        "onUpdate:modelValue": [
          _cache[14] || (_cache[14] = ($event: any) => ((address.value.stateId) = $event)),
          _cache[15] || (_cache[15] = ($event: any) => (_unref(handleFieldChange)('stateId', $event)))
        ],
        modelModifiers: { number: true },
        options: _unref(statesOptions)
      }, null, 8, ["schema", "modelValue", "options"]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).postalCode,
        modelValue: address.value.postalCode,
        "onUpdate:modelValue": [
          _cache[16] || (_cache[16] = ($event: any) => ((address.value.postalCode) = $event)),
          _cache[17] || (_cache[17] = ($event: any) => (_unref(handleFieldChange)('postalCode', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      (_unref(countryOptions)?.length > 1)
        ? (_openBlock(), _createBlock(BaseFormField, {
            key: 1,
            schema: _unref(addressSchema).countryId,
            modelValue: address.value.countryId,
            "onUpdate:modelValue": [
              _cache[18] || (_cache[18] = ($event: any) => ((address.value.countryId) = $event)),
              _cache[19] || (_cache[19] = ($event: any) => (_unref(handleFieldChange)('countryId', $event)))
            ],
            modelModifiers: { number: true },
            options: _unref(countryOptions)
          }, null, 8, ["schema", "modelValue", "options"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})